import { SeekControls } from ".";
import { useControlBar } from "../../contexts/ControlBar";

import { Center } from "../Center";
import { useSeekBar } from "../../contexts/SeekBar";

export const CenteredSeekControls = () => {
  const { isActive } = useControlBar();
  const { isPointerDown, isPointerInside } = useSeekBar();

  const show = isActive && !isPointerDown && !isPointerInside;

  return (
    <Center show={show}>
      <SeekControls big />
    </Center>
  );
};
